<template>
    <div>
        <h1>
            An error occured during the authentication process, please try again
            later.
        </h1>
    </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
    name: 'OidcCallbackError',
})
</script>
